
function Center() {







    return (
        <main >
            <section className="masterMain" name='skizb'>
                <div className="fonMaster">
                    <div className='text1'>



                        <div className="stats">
                            <span><strong>10000+</strong><br />հաճախորդ</span>
                            <span ><strong>Մինչև 2</strong><br />տարի երաշխիք</span>
                            <span><strong>15+ տարվա</strong><br />փորձ</span>
                        </div>

                        <h1>Պնևմոկախման նորոգում</h1>
                        <p>
                            Գործարանային նորոգում և արհեստավարժ ավտոսպասարկման
                            վերլուծական մոտեցում Audi, BMW, Mercedes, Tesla, Porsche և այլ
                            ավտոմեքենաների համար։
                        </p>
                    </div>
                </div>
            </section>
            <section className='tesakani' name="catalog"   >

                <div onClick={() => { window.location.href = '/amortization' }}  >

                    <img src="image/amor.png" alt='/s' />
                    <h1>Ամորտիզատորներ</h1>


                </div>

                <div onClick={() => { window.location.href = '/pnevmo' }}  >
                    <img src="image/penvstoy.png" alt='/s' />
                    <h1>Պնևմոստոյկաներ</h1>
                </div>

                <div onClick={() => { window.location.href = '/compressor' }} >
                    <img src="image/kompres3.png" alt='/s' />
                    <h1>Կոմպրեսորներ</h1>
                </div>
                <div onClick={() => { window.location.href = '/airbalone' }}  >
                    <img src="image/puchik.png" alt='/s' />
                    <h1>Պնևմոբալոններ</h1>
                </div>


            </section>
            <section className='zexj'>

                <div >
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>


                </div>
                <div name="garanty">
                    <h1>- 5000 Դրամ</h1>
                    <p>Զեղչ պնևմոկախման նորոգման համար</p>
                </div>





            </section>
            <section className='info' name="about"  >
                <div>
                    <div className='log'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path><path d="M17 18h1"></path><path d="M12 18h1"></path><path d="M7 18h1"></path></svg>
                    </div>
                    <h1>Վաճառք արտադրողից</h1>
                    <p>Ուղղակի մատակարարում գործարանից առանց <br /> միջնորդների</p>



                </div>
                <div>
                    <div className='log'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"></path><path d="M6 18h12"></path><path d="M6 14h12"></path><rect width="12" height="12" x="6" y="10"></rect></svg>
                    </div>
                    <h1>Առկայություն պահեստում</h1>
                    <p>Մեծ տեսականի և ամենատարածված մոդելների <br /> առկայություն</p>
                </div>
                <div>
                    <div className='log'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h1>Սպասարկում և սերվիս</h1>
                    <p>Մասնագիտական սպասարկում և երաշխիքային <br /> սերվիս</p>

                </div>




            </section>



            <section className='erashxiq'   >
                <div className='vernagir1'>
                    <h1>Երաշխիք և սպասարկում</h1>
                    <p>Մենք երաշխավորում ենք մեր արտադրանքի և վերանորոգման բարձր որակը և<br /> տրամադրում  լրիվ սպասարկում և երաշխիք</p>
                </div>
                <div className='hat4'>
                    <div className='patm'>
                        <div className='log2'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                        </div>
                        <div>

                            <h2>Երաշխիք մինչև 24 ամիս</h2>
                            <p>Բոլոր աշխատանքների վրա տրամադրվում է մինչև 24 ամսվա երաշխիք</p>
                        </div>


                    </div>
                    <div className='patm'>
                        <div className='log2'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg></div>
                        <div>
                            <h2>Որակի ապահովում</h2>
                            <p>Բոլոր ապրանքները ստուգված են և համապատասխանում  <br />են միջազգային չափանիշներին</p>
                        </div>
                    </div>
                    <div className='patm'>
                        <div className='log2'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg></div>

                        <div>
                            <h2>Անվճար Խորհրդատվություն</h2>
                            <p>Երաշխիքային սպասարկում և պրոֆեսիոնալ վերանորոգում ամբողջությամբ</p>
                        </div>
                    </div>
                    <div className='patm'>
                        <div className='log2'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></div>
                        <div>

                            <h2>24/7 Աջակցություն</h2>
                            <p>Մենք միշտ պատրաստ ենք օգնել և խորհուրդ տալ <br />  ցանկացած պահի</p>
                        </div>
                    </div>



                </div>










            </section>
            <section className='kapMezHet' name="contact" >
                <div className='vernagir2'>
                    <h1>Կապ մեզ հետ</h1>
                    <p>Մենք միշտ հաճույքով կպատասխանենք ձեր հարցերին և կօգնենք ընտրել <br /> ճիշտ արտադրանք</p>
                </div>


                <div className='kapMezHetText'>



                    <div onClick={() => { window.location.href = 'tel:+37494474816' }}   >
                        <div className='k1'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        </div>
                        <h4>Հեռախոս</h4>
                        <p>+374 94 474816</p>
                    </div>
                    <div onClick={() => { window.open("mailto:armoo@rambler.ru") }}    >
                        <div className='k2'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg></div>
                        <h4>Էլ. փոստ</h4>
                        <p>armoo@rambler.ru</p>
                    </div>
                    <div onClick={() => { window.open('https://yandex.com/maps/-/CLvarJMZ') }}       >
                        <div className='k3'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                        </div>
                        <h4>Հասցե</h4>
                        <p>Աշտարակ Տիգրան Մեծ 46/ա</p>
                    </div>
                    <div><div className='k4'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg></div><h4>Աշխատանքային ժամեր</h4><p>Երկ-Ուրբ: 09:00 - 18:00 <br />Շաբաթ: 10:00 - 16:00 <br />Կիրակի: 10:00 - 16:00</p></div>



                </div>

            </section>
        </main>
    )
}

export default Center
